var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 107.942,
    height: 95.206,
    viewBox: "321.029 288.286 107.942 95.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 351"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m369.368 291.537-47.458 82.2c-2.503 4.336.626 9.755 5.632 9.755h94.916c5.006 0 8.135-5.419 5.632-9.755l-47.458-82.2c-2.503-4.335-8.761-4.335-11.264 0Z",
    fill: "#ffcd00",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 412"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 350"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.961 323.479c0 3.844-3.116 33.586-6.961 33.586s-6.961-29.742-6.961-33.586a6.961 6.961 0 1 1 13.922 0Z",
    fill: "#fff",
    fillRule: "evenodd",
    "data-name": "\\u30D1\\u30B9 413"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.298 367.373a4.702 4.702 0 1 1 0 .1z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.487a424be16c3a71582e9b6fca8042e3.svg";
export { ForwardRef as ReactComponent };